import { Box } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { SpecCreator } from "./SpecCreator";
import { useDialogProps } from "legacy-components/dialog/Dialog";
interface SpecUploaderProps {
  apiId: string;
  version: string;
  refreshDeployments: ()=>void;
}

export const SpecUploader: React.FC<SpecUploaderProps> = React.memo(({ apiId, version, refreshDeployments}) => {
    const { open, toggle } = useDialogProps();

    const handler = () => {
        toggle();
    };

    return (
    <Box >
      <Box style={{ borderStyle: "dashed", height: "150px", width: "450px", marginBottom: "20px",  display: "flex", flexDirection:"column" ,justifyContent: "center", alignItems: "center", borderColor:"#b7b9c3" }} onClick={handler}>
        <CloudUploadIcon style={{color: "#b7b9c3"}}/>
        <FormattedMessage defaultMessage={"Upload Api Specification"} />
      </Box>
      <SpecCreator apiId={apiId} version={version} onOpen={open} onClose={toggle} refreshDeployments={refreshDeployments}/>
      </Box>
    );
})
